/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParameterNameResponseDto
 */
export interface ParameterNameResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ParameterNameResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterNameResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterNameResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterNameResponseDto
     */
    unit: string;
    /**
     * 
     * @type {Date}
     * @memberof ParameterNameResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ParameterNameResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ParameterNameResponseDto interface.
 */
export function instanceOfParameterNameResponseDto(value: object): value is ParameterNameResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ParameterNameResponseDtoFromJSON(json: any): ParameterNameResponseDto {
    return ParameterNameResponseDtoFromJSONTyped(json, false);
}

export function ParameterNameResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterNameResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'unit': json['unit'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ParameterNameResponseDtoToJSON(json: any): ParameterNameResponseDto {
    return ParameterNameResponseDtoToJSONTyped(json, false);
}

export function ParameterNameResponseDtoToJSONTyped(value?: ParameterNameResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'unit': value['unit'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

